import {
    STATUS_COLORS
} from "../../constants/statusColors";

export default function StatusBadge({

    status,

    size = "md",

    className = ""

}){

    const colors =

        STATUS_COLORS[status] ||

        {

            background:"#F1F5F9",

            color:"#475569"

        };

    return(

        <span

            className={`
                crm-status-badge
                crm-status-${size}
                ${className}
            `}

            style={{

                background:colors.background,

                color:colors.color

            }}

        >

            {

                status

                    ?.replaceAll("_"," ")

                    ?.replace(

                        /\b\w/g,

                        c=>c.toUpperCase()

                    )

            }

<style>{`

.crm-status-badge{

    display:inline-flex;

    align-items:center;

    justify-content:center;

    border-radius:999px;

    font-weight:600;

    white-space:nowrap;

    user-select:none;

}

.crm-status-sm{

    height:24px;

    padding:0 10px;

    font-size:11px;

}

.crm-status-md{

    height:28px;

    padding:0 12px;

    font-size:12px;

}

.crm-status-lg{

    height:34px;

    padding:0 16px;

    font-size:13px;

}

`}</style>

        </span>

    );

}